import DocumentLink from 'components/ui-components/DocumentLink';
import { branchTermSingular } from 'utils/terminology';

const GovernmentBody = () => (
  <section className="pt-32">
    <div className="fl ai-c">
      <h3 className="ff-body fs-20 lh-1-4 tc-main m-0 cef-ui-inner-form-section__title">
        Download Application Form
      </h3>
    </div>
    <DocumentLink
      text="Trade Account Application Form"
      type="PDF"
      link="https://assets.cef.co.uk/misc/cef/CEF_Account_Application.pdf"
      className="ff-body fs-16 fw-400 mb-0 pb-32"
    />
    <div className="fl ai-c">
      <h3 className="ff-body fs-20 lh-1-4 tc-main m-0 cef-ui-inner-form-section__title">
        How to Apply
      </h3>
    </div>
    <p className="ff-body fs-16 fw-400 tc-secondary mb-0">
      You can apply by post or drop off the printed form at your nearest CEF{' '}
      {branchTermSingular}.
    </p>
  </section>
);

export default GovernmentBody;
